import React, {useState, useEffect} from "react";
import Axios from "axios";
import {saveAs} from "file-saver";
import {Form, Select, Row, Col, Button, DatePicker, Modal} from "antd";
import {errorHandler, TableRender, xaMessage} from "../../common";
import {useTranslation} from "react-i18next";
import {
  jsonToCSV,
  dateWithDashFormat,
  removeDashAndSpace,
  convertDateString,
} from "../../utils/stringHelper";
import "antd/dist/antd.css";
import "./index.css";

const {RangePicker} = DatePicker;
const {Option} = Select;

/* Main Component */
const EquipmentOperLogList = () => {
  const [projectList, setProjectList] = useState([]);
  const [operLogList, setOperLogList] = useState([]);
  const [isShowLoading, setIsShowLoading] = useState(false);

  const [form] = Form.useForm();

  /** i18next */
  const {t} = useTranslation();

  const columns = [
    {
      title: "프로젝트 ID",
      dataIndex: "project_id",
      width: 80,
    },
    {
      title: "프로젝트명",
      dataIndex: "project_nm",
      width: 250,
    },
    {
      title: "운전자명",
      dataIndex: "driver_nm",
      width: 120,
    },
    {
      title: "운전자 연락처",
      dataIndex: "driver_phone_no",
      width: 150,
    },
    {
      title: "장비명",
      dataIndex: "asset_nm",
      width: 120,
    },
    {
      title: "사업자 등록 번호",
      dataIndex: "biz_no",
      width: 120,
    },
  ];

  const handleFetchProjectList = async () => {
    try {
      const {data} = await Axios.get("/common/project/list");
      setProjectList(data.filter((item) => item.project_mng_sq !== 0));
    } catch (err) {
      errorHandler(t("message_error_beginning"), err);
    }
  };

  const handleFetchOperLogList = async () => {
    const {selectedProjects, selectedDate} = form.getFieldsValue();

    if (!selectedProjects || !selectedDate) {
      xaMessage("warn", "입력 항목 확인");
      return;
    }

    const startDt = selectedDate[0].format("YYYYMMDD");
    const endDt = selectedDate[1].format("YYYYMMDD");

    try {
      setIsShowLoading(true);
      const {data} = await Axios.get("/equip/log/list", {
        params: {
          project_list: selectedProjects,
          start_dt: startDt,
          end_dt: endDt,
        },
      });

      if (data.length > 0) {
        setOperLogList(data);
      }
    } catch (err) {
      console.log(err);
      errorHandler(t("message_error_beginning"), t("message_search_failed"), null);
    }
    setIsShowLoading(false);
  };

  const handleDownloadCSV = () => {
    if (operLogList.length === 0) {
      xaMessage("error", "확인 내용 없음!");
      return;
    }

    const {selectedDate} = form.getFieldsValue();

    const fileName = `${selectedDate[0].format("YYYYMMDD")}-${selectedDate[1].format("YYYYMMDD")}_operation_log_list.csv`;
    const csvString = jsonToCSV(
      operLogList.map((item) => ({
        "프로젝트 ID": item.project_id,
        프로젝트명: item.project_nm,
        운전자명: item.driver_nm,
        "운전자 연락처": String(item.driver_phone_no),
        장비명: item.asset_nm,
        "사업자 등록 번호": item.biz_no,
      }))
    );

    return saveAs(new Blob(["\uFEFF" + csvString], {type: "text/csv;charset=utf-8;"}), fileName);
  };

  useEffect(() => {
    handleFetchProjectList();
  }, []);

  /* Renderer */
  return (
    <>
      {/* 조회 조건 영역 */}
      <div className="search-area common-search-area-form">
        <Form form={form}>
          <Row className="search-area-row-1">
            <Col span={12} key={0} className="search-area-column">
              <Form.Item name="selectedProjects" label="프로젝트">
                <Select
                  className="equip-log-select-project"
                  mode="multiple"
                  showSearch
                  optionFilterProp="children"
                  allowClear
                >
                  <Option>{t("selector_select")}</Option>
                  {projectList.map((el) => (
                    <Option key={el.project_mng_sq} value={el.project_mng_sq}>
                      [{el.project_mng_sq}] {el.f_proj_nm}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} key={2}>
              <Form.Item name="selectedDate" label="일자">
                <RangePicker name="date" size="small" style={{width: 220, height: 35}} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row className="search-button-area">
          <Button type="primary" onClick={handleFetchOperLogList}>
            {t("button_search_inquiry")}
          </Button>
          <Button
            className="button-margin-left"
            type="default"
            onClick={handleDownloadCSV}
            disabled={operLogList.length === 0}
          >
            {t("button_download_csv")}
          </Button>
        </Row>
      </div>
      <TableRender
        columns={columns}
        dataSource={operLogList}
        isLoading={isShowLoading}
        pagination={false}
        rowKey="index"
      />
    </>
  );
};

export default EquipmentOperLogList;
